// @flow

import type { StoreResourceDef } from 'app/core/types'

export const actions: StoreResourceDef<> = {
  resourceType: 'actions',
}
